import EmojiPicker from "emoji-picker-react";
import React, { Fragment, useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addEmoji, removeEmoji } from "../../../../REDUX/actions/emoji";
import userAvatar from "../../../../Images/Images/avatar.png";
import {
  addFavorite,
  deleteFavorite,
} from "../../../../REDUX/actions/favorites";
import { useTranslation } from "react-i18next";
import { Overlay } from "react-bootstrap";
import { IMAGE_END_POINT } from "../../../../Api/EndPoints";

export const emojisCategories = [
  {
    category: "suggested",
    name: "Récemment utilisé",
  },
  {
    category: "smileys_people",
    name: "Visages et personnes",
  },
  {
    category: "animals_nature",
    name: "Animaux et nature",
  },
  {
    category: "food_drink",
    name: "Nourriture et boissons",
  },
  {
    category: "travel_places",
    name: "Voyages et lieux",
  },
  {
    category: "activities",
    name: "Activités",
  },
  {
    category: "objects",
    name: "Objets",
  },
  {
    category: "symbols",
    name: "Symboles",
  },
  {
    category: "flags",
    name: "Drapeaux",
  },
];

export const FavIcon = () => (
  <svg
    width="16"
    class="scale-1-1 fav-icon"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="vuesax/linear/star" class="t-02">
      <g id="star" class="t-02">
        <path
          class="t-02"
          id="Vector"
          d="M9.15327 2.34001L10.3266 4.68668C10.4866 5.01334 10.9133 5.32668 11.2733 5.38668L13.3999 5.74001C14.7599 5.96668 15.0799 6.95334 14.0999 7.92668L12.4466 9.58001C12.1666 9.86001 12.0133 10.4 12.0999 10.7867L12.5733 12.8333C12.9466 14.4533 12.0866 15.08 10.6533 14.2333L8.65994 13.0533C8.29994 12.84 7.70661 12.84 7.33994 13.0533L5.34661 14.2333C3.91994 15.08 3.05327 14.4467 3.42661 12.8333L3.89994 10.7867C3.98661 10.4 3.83327 9.86001 3.55327 9.58001L1.89994 7.92668C0.926606 6.95334 1.23994 5.96668 2.59994 5.74001L4.72661 5.38668C5.07994 5.32668 5.50661 5.01334 5.66661 4.68668L6.83994 2.34001C7.47994 1.06668 8.51994 1.06668 9.15327 2.34001Z"
          stroke="#414A6E"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        ></path>
      </g>
    </g>
  </svg>
);

export const ReactIcon = () => (
  <svg
    class="scale-1-1"
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      class="t-02"
      d="M14.8405 1.83337H7.15884C3.82217 1.83337 1.83301 3.82254 1.83301 7.15921V14.8317C1.83301 18.1775 3.82217 20.1667 7.15884 20.1667H14.8313C18.168 20.1667 20.1572 18.1775 20.1572 14.8409V7.15921C20.1663 3.82254 18.1772 1.83337 14.8405 1.83337ZM7.79134 5.84837C8.73551 5.84837 9.51467 6.61837 9.51467 7.57171C9.51467 8.52504 8.74467 9.29504 7.79134 9.29504C6.83801 9.29504 6.06801 8.50671 6.06801 7.56254C6.06801 6.61837 6.84717 5.84837 7.79134 5.84837ZM10.9997 17.49C8.53384 17.49 6.52634 15.4825 6.52634 13.0167C6.52634 12.375 7.04884 11.8434 7.69051 11.8434H14.2905C14.9322 11.8434 15.4547 12.3659 15.4547 13.0167C15.473 15.4825 13.4655 17.49 10.9997 17.49ZM14.208 9.27671C13.2638 9.27671 12.4847 8.50671 12.4847 7.55337C12.4847 6.60004 13.2547 5.83004 14.208 5.83004C15.1613 5.83004 15.9313 6.60004 15.9313 7.55337C15.9313 8.50671 15.1522 9.27671 14.208 9.27671Z"
      fill="#414A6E"
    ></path>
  </svg>
);

const EmojiPickerContainer = ({
  emojis,
  messageId,
  direction,
  commentRef,
  isFavored,
  actionType,
  disableFavorite,
}) => {
  const target = useRef(null);
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.userReducer);
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const [overlayContent, setOverlayContent] = useState(null);
  const { loading } = useSelector((state) => state.emojiReducer);
  const groupedEmojis = useMemo(() => {
    const data = emojis?.reduce((acc, emoji) => {
      const unified = emoji?.attributes?.unified;
      if (!acc[unified]) {
        acc[unified] = [emoji];
      } else {
        acc[unified] = [...acc[unified], emoji];
      }
      return acc;
    }, {});
    return data ? Object.values(data) : [];
  }, [emojis]);

  const onEmojiClick = (emojiObject) => {
    if (loading) return;
    const foundEmoji = emojis?.find(
      (emoji) => +user?.id === +emoji?.attributes?.user?.data?.id
    );
    const isSame = foundEmoji?.attributes?.unified === emojiObject.unified;
    if (isSame) return;
    dispatch(
      addEmoji(
        {
          url: emojiObject.imageUrl,
          comment: messageId,
          user: user?.id,
          unified: emojiObject.unified,
        },
        actionType,
        foundEmoji,
        () => setShowEmojiPicker(false)
      )
    );
  };

  const toggleEmojiPicker = () => {
    setShowEmojiPicker(!showEmojiPicker);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!commentRef.current.contains(event.target)) {
        setShowEmojiPicker(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [commentRef]);

  return (
    <div>
      <div
        className={`d-flex align-items-center overflow-auto no-scrollbar gap-1 position-absolute emoji-top mt-1 w-100 ${
          direction === "LEFT" ? "ms-n2" : "justify-content-end ms-2"
        }`}
      >
        {direction === "LEFT" && (
          <>
            {!disableFavorite && (
              <button
                onClick={() =>
                  dispatch(
                    isFavored
                      ? deleteFavorite(messageId)
                      : addFavorite(messageId)
                  )
                }
                className={`bg-white bg-white size-24px alignC border-darkGrey br5 border ${
                  isFavored ? "favored" : ""
                }`}
              >
                <FavIcon />
              </button>
            )}
            <button
              onClick={toggleEmojiPicker}
              className={`bg-white bg-white size-24px alignC border-darkGrey br5 border`}
            >
              <ReactIcon />
            </button>
          </>
        )}
        {emojis?.length > 0 && (
          <div className="flex-1">
            <div
              className={`d-flex align-items-center gap-1 w-100 ${
                direction === "LEFT" ? "" : "justify-content-end"
              }`}
            >
              {groupedEmojis?.map((groupedEmoji) => {
                const emoji = groupedEmoji?.[0];
                const currentUser = emojis.find(
                  (e) =>
                    +e?.attributes?.user?.data?.id === +user?.id &&
                    emoji?.attributes?.unified === e?.attributes?.unified
                );
                return (
                  <>
                    <div
                      ref={target}
                      key={emoji?.id}
                      className="py-1 px-2 alignC h-24px position-relative overflow-hidden br5 d-flex align-items-center justify-content-center gap-2 border-darkGrey br5 border cursor-pointer"
                      onMouseOver={() =>
                        setOverlayContent(
                          groupedEmoji?.map(
                            (emoji) => emoji?.attributes?.user?.data
                          )
                        )
                      }
                      onMouseOut={() => setOverlayContent(null)}
                      onClick={
                        currentUser
                          ? () =>
                              dispatch(
                                removeEmoji(emoji, messageId, actionType)
                              )
                          : undefined
                      }
                    >
                      <div className="bg-white w-100 h-100 position-absolute top-0 left-0 opacity-75" />
                      <img
                        src={emoji?.attributes?.url}
                        alt={emoji?.attributes?.unified}
                        className="position-relative z-1 size-16px"
                      />
                      <span className="position-relative z-1 f14 text-dark">
                        {groupedEmoji?.length || 0}
                      </span>
                    </div>
                  </>
                );
              })}
              <Overlay
                target={target.current}
                show={overlayContent || true}
                placement="top-start"
              >
                {(props) => {
                  return (
                    <div
                      className="d-flex flex-column"
                      {...props}
                      style={{
                        ...props.style,
                        zIndex: 99999,
                        boxShadow: "0px 3px 6px #0000001a",
                      }}
                    >
                      {overlayContent?.map((user) => {
                        const photoUrl =
                          user?.attributes?.photo?.data?.attributes?.url;
                        const fullName = [
                          user?.attributes?.firstName,
                          user?.attributes?.lastName,
                          user?.attributes?.transporter?.data?.attributes?.name,
                          user?.attributes?.storekeeper?.data?.attributes?.name,
                        ]
                          .filter(Boolean)
                          .join(" ");

                        let title = "";
                        if (user?.attributes?.userRole === 1) {
                          title = t("Administrator");
                        } else if (user?.attributes?.userRole === 0) {
                          title =
                            user?.attributes?.profil?.data?.attributes?.reseller
                              ?.data?.attributes?.name ?? "";
                        } else if (user?.attributes?.userRole === 2) {
                          title =
                            user?.attributes?.business_affiliate?.data
                              ?.attributes?.name;
                        } else if (user?.attributes?.userRole === 3) {
                          title = t("Transporter");
                        } else if (user?.attributes?.userRole === 4) {
                          title = t("Storekeeper");
                        }
                        return (
                          <div className="d-flex align-items-center p-12px bg-white br5">
                            <img
                              src={
                                photoUrl
                                  ? `${IMAGE_END_POINT}${photoUrl}`
                                  : userAvatar
                              }
                              alt=""
                              width={34}
                              height={34}
                              className="ob-cover rounded-circle"
                            />

                            <div className="d-flex flex-column ms-2 ps-1">
                              {fullName?.trim()?.length > 0 && (
                                <p className="f14 mb-0 semi-bold text-dark">
                                  {fullName}
                                </p>
                              )}
                              <p className="f14 mb-0 text-brightGrey">
                                {title}
                              </p>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  );
                }}
              </Overlay>
            </div>
          </div>
        )}

        {direction === "RIGHT" && (
          <>
            {!disableFavorite && (
              <button
                onClick={() =>
                  dispatch(
                    isFavored
                      ? deleteFavorite(messageId)
                      : addFavorite(messageId)
                  )
                }
                className={`bg-transparent bg-white size-24px alignC border-darkGrey br5 border ${
                  isFavored ? "favored" : ""
                }`}
              >
                <FavIcon />
              </button>
            )}
            <button
              onClick={toggleEmojiPicker}
              className={`bg-transparent bg-white size-24px alignC border-darkGrey br5 border`}
            >
              <ReactIcon />
            </button>
          </>
        )}
      </div>
      <div
        className="position-absolute mt-n5"
        style={{
          bottom: "-70px",
          right: direction === "RIGHT" ? 0 : "unset",
          left: direction === "LEFT" ? 0 : "unset",
          zIndex: 1000,
        }}
      >
        <EmojiPicker
          open={showEmojiPicker}
          height={350}
          reactionsDefaultOpen
          searchPlaceHolder={t("Search")}
          categories={
            i18n.language?.toLowerCase()?.includes("fr") && emojisCategories
          }
          previewConfig={{
            defaultCaption: "",
            showPreview: false,
          }}
          onEmojiClick={onEmojiClick}
          hiddenEmojis={["1f1ee-1f1f1"]}
          reactions={[
            "1f44d",
            "1f44e",
            "1f64f",
            "2764-fe0f",
            "1f602",
            "2705",
            "274c",
          ]}
        />
      </div>
    </div>
  );
};

export default EmojiPickerContainer;
